import { render, staticRenderFns } from "./_base-drawer.vue?vue&type=template&id=6ef5091e&scoped=true&"
import script from "./_base-drawer.vue?vue&type=script&lang=js&"
export * from "./_base-drawer.vue?vue&type=script&lang=js&"
import style0 from "./_base-drawer.vue?vue&type=style&index=0&id=6ef5091e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ef5091e",
  null
  
)

export default component.exports